/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { EnrolmentRetryResponse } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Retry a specific enrolment by ID
 */
export const retryEnrolment = (
  enrolmentId: number,
  options?: SecondParameter<typeof backofficeRequest<EnrolmentRetryResponse>>,
) => {
  return backofficeRequest<EnrolmentRetryResponse>(
    { url: `/retry/enrolment/${enrolmentId}`, method: "POST" },
    options,
  )
}
export type RetryEnrolmentResult = NonNullable<
  Awaited<ReturnType<typeof retryEnrolment>>
>
